import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

/**
 * @typedef {React.ComponentProps<typeof Tooltip> & {
 *   maxWidth?: string
 *   topOffset?: string | number
 *   leftOffset?: string | number
 *   fontSize?: string
 *   borderRadius?: string | number
 * }} BlackTooltipProps
 */

const useStyles = makeStyles(() => ({
  popper: {
    '&[x-placement*="top"]': {
      // @ts-ignore
      top: ({ topOffset }) => {
        if (topOffset === undefined || topOffset === null) {
          return undefined;
        }

        return typeof topOffset === "number"
          ? `${topOffset}px !important`
          : `${topOffset} !important`;
      }
    },
    // @ts-ignore
    left: ({ leftOffset }) => {
      if (leftOffset === undefined || leftOffset === null) {
        return undefined;
      }

      return typeof leftOffset === "number"
        ? `${leftOffset}px !important`
        : `${leftOffset} !important`;
    }
  },
  tooltip: {
    // @ts-ignore
    maxWidth: ({ maxWidth }) => maxWidth || "500px",
    maxHeight: "500px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    // @ts-ignore
    fontSize: ({ fontSize }) => fontSize || "12px",
    // @ts-ignore
    borderRadius: ({ borderRadius }) => {
      if (borderRadius === undefined || borderRadius === null) {
        return undefined;
      }

      return typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius;
    },
    padding: "12px 17px",
    whiteSpace: "break-spaces",
    overflow:"hidden",
    textOverflow:"ellipsis",
    
  },
  tooltipArrow: {
    overflow: "visible"
  },
  arrow:{
    color: "#3F3F51"
  }
}));

/**
 * @type {React.ForwardRefExoticComponent<BlackTooltipProps & React.RefAttributes<any>>}
 */
const BlackTooltip = React.forwardRef(({ maxWidth, topOffset, leftOffset, fontSize, borderRadius, ...props }, ref) => {
  const classes = useStyles({ maxWidth, topOffset, leftOffset, fontSize, borderRadius });

  return <Tooltip ref={ref} classes={classes} {...props} />;
});

BlackTooltip.displayName = "BlackTooltip";

export default BlackTooltip;
